import React from 'react';

/**
 * Cosmetics/dress-up icon - a cute top hat paired with a small bag/satchel.
 * Communicates "fashion" and "accessories" for pets.
 */
export default function CosmeticsIcon({ size = 24, color = 'currentColor', className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Top hat */}
      {/* Brim */}
      <ellipse cx="9" cy="15" rx="7" ry="2.2" stroke={color} strokeWidth="1.4" fill={color} fillOpacity="0.08" />
      {/* Crown */}
      <rect x="5" y="7" width="8" height="8" rx="1" stroke={color} strokeWidth="1.4" fill={color} fillOpacity="0.05" />
      {/* Band */}
      <line x1="5" y1="12" x2="13" y2="12" stroke={color} strokeWidth="1.4" />
      {/* Top */}
      <line x1="5" y1="7" x2="13" y2="7" stroke={color} strokeWidth="1.4" strokeLinecap="round" />

      {/* Small bag/satchel beside the hat */}
      <rect x="16" y="11" width="6" height="7" rx="1.5" stroke={color} strokeWidth="1.3" fill={color} fillOpacity="0.08" />
      {/* Bag handle */}
      <path d="M17.5 11V9.5C17.5 8.7 18.2 8 19 8C19.8 8 20.5 8.7 20.5 9.5V11" stroke={color} strokeWidth="1.2" strokeLinecap="round" />
      {/* Bag flap */}
      <path d="M16 13.5H22" stroke={color} strokeWidth="1" />
      {/* Bag clasp */}
      <circle cx="19" cy="15" r="0.8" fill={color} />
    </svg>
  );
}
